(function () {
  'use strict';

  angular.module('wsLrs.directives').directive("wsDisableAnimate", function ($animate) {
    return function (scope, element) {
      $animate.enabled(false, element);
    };
  });
})();
